import axios from 'axios';
import { API_DOMAIN_NAME } from '../config/default';

const BASE_URL = process.env.REACT_APP_PORTAL_API;

const instance = axios.create({
    baseURL: BASE_URL,
    // withCredentials: true,
    headers: {
        'wapp-domain': API_DOMAIN_NAME
    }
});

export default instance;